'use client'

import { motion } from 'framer-motion'
import { Reveal } from '../Reveal'
import { Icon, ArrowIcon } from '../Icons'
import { services } from '@/lib/site-config'

export function Services(): React.ReactElement {
  return (
    <section id="services" className="section-pad relative overflow-hidden bg-charcoal-900">
      <div className="absolute inset-0 grid-overlay opacity-40" />

      <div className="container-x relative">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="eyebrow mb-5">خدماتنا</span>
          <h2 className="font-heading text-3xl font-extrabold text-white sm:text-4xl md:text-5xl">
            خدمات متكاملة في <span className="gold-text">المقاولات</span>
          </h2>
          <p className="mt-5 text-lg text-charcoal-300">
            نقدّم باقة شاملة من الخدمات تغطي مراحل المشروع من الأساس حتى التسليم.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group card-surface relative flex flex-col p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-gold-500/40"
            >
              {/* Icon */}
              <div className="mb-5 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-gold-500/10 text-gold-300 transition-colors duration-300 group-hover:bg-gold-gradient group-hover:text-charcoal-950">
                <Icon name={service.icon} className="h-7 w-7" />
              </div>

              <h3 className="font-heading text-xl font-bold text-white">{service.title}</h3>
              <p className="mt-3 flex-1 leading-relaxed text-charcoal-300">
                {service.description}
              </p>

              <a
                href="#quote"
                className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-gold-300 transition-colors group-hover:text-gold-200"
              >
                اطلب الخدمة
                <ArrowIcon className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
              </a>

              {/* corner accent */}
              <span className="pointer-events-none absolute left-0 top-0 h-10 w-10 rounded-tr-2xl border-l-2 border-t-2 border-gold-500/0 transition-all duration-300 group-hover:border-gold-500/60" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
